// pages/Pricing/styles.js

import styled from "styled-components";
import { motion } from "framer-motion";
import { Container } from "../../styles/components";

export const PricingWrapper = styled.div`
    min-height: calc(100vh - 64px);
    background: ${props => props.theme.colors.background.alt};
    padding: ${props => props.theme.spacing['4xl']} 0;
`;

export const PricingHeader = styled.div`
    text-align: center;
    max-width: 800px;
    margin: 0 auto;
    margin-bottom: ${props => props.theme.spacing['3xl']};

    h1 {
        font-size: ${props => props.theme.typography.sizes['4xl']};
        font-weight: ${props => props.theme.typography.weights.bold};
        margin-bottom: ${props => props.theme.spacing.md};
        color: ${props => props.theme.colors.text.primary};

        @media (max-width: ${props => props.theme.breakpoints.md}) {
            font-size: ${props => props.theme.typography.sizes['3xl']};
        }
    }

    p {
        font-size: ${props => props.theme.typography.sizes.lg};
        color: ${props => props.theme.colors.text.secondary};
        margin-bottom: ${props => props.theme.spacing.xl};
    }
`;


export const PricingSection = styled.div`
    max-width: 1200px;
    margin: 0 auto;
    padding: ${props => props.theme.spacing.xl};
`;

export const PricingGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: ${props => props.theme.spacing.xl};
    max-width: 1200px;
    margin: 0 auto;

    @media (max-width: ${props => props.theme.breakpoints.lg}) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: ${props => props.theme.breakpoints.md}) {
        grid-template-columns: 1fr;
        max-width: 500px;
        padding: 0 ${props => props.theme.spacing.md};
    }
`;

export const ModalOverlay = styled(motion.div)`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: ${props => props.theme.spacing.xl};
    overflow-y: auto;
`;

export const ComparisonTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    margin-top: ${props => props.theme.spacing.xl};
    background: white;
    border-radius: ${props => props.theme.borderRadius.lg};
    overflow: hidden;
    box-shadow: ${props => props.theme.shadows.sm};

    th, td {
        padding: ${props => props.theme.spacing.md};
        text-align: left;
        border-bottom: 1px solid ${props => props.theme.colors.border};
    }

    th {
        background: ${props => props.theme.colors.background.alt};
        font-weight: ${props => props.theme.typography.weights.semibold};
    }

    td:first-child {
        font-weight: ${props => props.theme.typography.weights.medium};
    }

    @media (max-width: ${props => props.theme.breakpoints.md}) {
        display: block;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }
`;

export const PricingFAQ = styled(Container)`
    margin-top: ${props => props.theme.spacing['4xl']};
    max-width: 800px;

    h2 {
        text-align: center;
        font-size: ${props => props.theme.typography.sizes['2xl']};
        margin-bottom: ${props => props.theme.spacing.xl};
    }
`;

export const FAQItem = styled.div`
    background: white;
    border-radius: ${props => props.theme.borderRadius.lg};
    padding: ${props => props.theme.spacing.xl};
    margin-bottom: ${props => props.theme.spacing.md};
    box-shadow: ${props => props.theme.shadows.sm};

    h3 {
        font-size: ${props => props.theme.typography.sizes.lg};
        margin-bottom: ${props => props.theme.spacing.sm};
        color: ${props => props.theme.colors.text.primary};
    }

    p {
        color: ${props => props.theme.colors.text.secondary};
    }
`;


export const ActiveSubscriptionBanner = styled.div`
    background: ${props => props.theme.colors.primary.main}15;
    padding: ${props => props.theme.spacing.md};
    text-align: center;
    margin-bottom: ${props => props.theme.spacing.xl};

    p {
        color: ${props => props.theme.colors.text.primary};
        
        &:first-child {
            font-weight: ${props => props.theme.typography.weights.medium};
        }
        
        &:last-child {
            font-size: ${props => props.theme.typography.sizes.sm};
            color: ${props => props.theme.colors.text.secondary};
            margin-top: ${props => props.theme.spacing.xs};
        }
    }
`;


// pages/Pricing/styles.js

// Add these new styled components to your existing styles file
export const PricingTabs = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${props => props.theme.spacing.md};
    margin-top: ${props => props.theme.spacing.xl};
    
    @media (max-width: ${props => props.theme.breakpoints.sm}) {
        flex-direction: column;
        gap: ${props => props.theme.spacing.sm};
    }
`;

export const TabButton = styled.button`
    padding: ${props => props.theme.spacing.md} ${props => props.theme.spacing.xl};
    font-size: ${props => props.theme.typography.sizes.lg};
    font-weight: ${props => props.theme.typography.weights.medium};
    color: ${props => props.active ? props.theme.colors.primary.dark : props.theme.colors.text.secondary};
    background: ${props => props.active ? props.theme.colors.primary.main + '15' : 'transparent'};
    border: 2px solid ${props => props.active ? props.theme.colors.primary.dark : 'transparent'};
    border-radius: ${props => props.theme.borderRadius.full};
    transition: all ${props => props.theme.transitions.normal};

    &:hover {
        color: ${props => props.theme.colors.primary.main};
        background: ${props => props.theme.colors.primary.main + '10'};
    }

    @media (max-width: ${props => props.theme.breakpoints.sm}) {
        width: 100%;
        padding: ${props => props.theme.spacing.sm} ${props => props.theme.spacing.lg};
    }
`;


